import {
  SITE_WEEK_DAYS,
  STAFF_CLOSE_HOUR_IN_SECONDS,
} from '../../../configs/siteAndTrustAttributes';
import {
  useSiteIntAttributes,
  useSiteNumericArrayAttribute,
} from '../../../hooks/useAttribute';
import { formatDateOnlyISO, SECONDS_IN_HOUR } from '../../../utils/dateUtil';
import { useMaxAndMinFutureDateForBookingForOnlineBooking } from '../../../hooks/patient/booking/useMaxAndMinFutureDateForBooking';
import { useBankHolidays } from '../../../query/bankHolidays';
import { UNSAFE_FILTER_WITH_NO_PAGINATION } from '../../../hooks/usePaginatedFilters';
import { useFilterDateWeekDayAndNotBankHoliday } from '../../../hooks/appointments/useFilterDateWeekDayAndNotBankHoliday';
import { useSaveWaitingListWithCancelOtherApptsChoose } from '../../../hooks/patient/waitingList/useSaveWaitingList';
import { useValidateWaitingList } from '../../../hooks/patient/waitingList/useValidateWaitingList';
import { useWaitingListURL } from '../../../hooks/patient/waitingList/useWaitingListURL';
import { useCallback } from 'react';
import { useSiteHourRange } from '../../../hooks/site/useSiteHourRange';
import { useDeleteWaitingList } from '../../../hooks/patient/waitingList/useDeleteWaitingList';

export const useWaitingListFormData = () => {
  const { save, isLoading: isSavingWaitingList } =
    useSaveWaitingListWithCancelOtherApptsChoose();
  const validate = useValidateWaitingList();
  const helpURL = useWaitingListURL('help');
  const onSubmit = useCallback(() => {
    if (validate()) {
      save();
    }
  }, [validate, save]);
  const { slots } = useSiteHourRange();
  const { deleteWaitingList, isLoading: isDeleteWaitingListLoading } =
    useDeleteWaitingList();

  const [closeHourInSeconds = 0] = useSiteIntAttributes(
    STAFF_CLOSE_HOUR_IN_SECONDS,
  );
  const closeHour = Math.ceil(closeHourInSeconds / SECONDS_IN_HOUR);

  const { minDate, maxDate } =
    useMaxAndMinFutureDateForBookingForOnlineBooking();

  const { isLoading: isBankHolidaysLoading, data: bankHolidaysData } =
    useBankHolidays({
      ...UNSAFE_FILTER_WITH_NO_PAGINATION,
      fromDate: formatDateOnlyISO(minDate),
      toDate: formatDateOnlyISO(maxDate),
    });

  const weekDays = useSiteNumericArrayAttribute(SITE_WEEK_DAYS);

  const isDayAvailable = useFilterDateWeekDayAndNotBankHoliday({
    weekDays,
    bankHolidays: bankHolidaysData?.data,
  });

  const isLoading =
    isSavingWaitingList || isDeleteWaitingListLoading || isBankHolidaysLoading;

  return {
    isLoading,
    helpURL,
    onSubmit,
    slots,
    deleteWaitingList,
    closeHour,
    minDate,
    maxDate,
    isDayAvailable,
  };
};
